// extracted by mini-css-extract-plugin
export var actionButton = "_pe-0";
export var actionMenuContainer = "_pe-i";
export var bubble = "_pe-2";
export var bubbleActionMenu = "_pe-j";
export var bubbleContext = "_pe-6";
export var bubbleItems = "_pe-7";
export var customer = "_pe-3";
export var divider = "_pe-8";
export var fileList = "_pe-9";
export var hiddenComment = "_pe-o";
export var infoAbove = "_pe-a";
export var internal = "_pe-4";
export var lightActionButton = "_pe-1";
export var link = "_pe-b";
export var merchant = "_pe-5";
export var message = "_pe-c";
export var profilePicture = "_pe-e";
export var quillToolbarContainer = "_pe-f";
export var senderDate = "_pe-g";
export var senderDateCustomer = "_pe-h";
export var senderName = "_pe-d";
export var time = "_pe-k";
export var uploadedImage = "_pe-l";
export var username = "_pe-m";
export var xsmall = "_pe-n";